const Footer = () => {
  return (
    <footer className="bg-black border-t border-neutral-800 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/1160cded-7576-4d06-81be-dbb4ac665a4d.png"
                alt="미래인재학원"
                className="w-12 h-12 object-contain"
              />
              <div>
                <h5 className="text-white font-bold text-lg">미래인재학원</h5>
                <p className="text-yellow-400 text-xs">ELITE OF FUTURE</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-neutral-500">
              체계적인 교육 시스템과<br />
              최고의 강사진이 함께하는<br />
              프리미엄 교육기관
            </p>
            <p className="text-xs text-neutral-600 mt-3">
              입학성적 및 학원 정보는 전지점 합산입니다.
            </p>
          </div>

          <div>
            <h5 className="text-yellow-400 font-bold mb-6 text-sm tracking-wider">캠퍼스</h5>
            <ul className="space-y-3 text-sm text-neutral-500">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-yellow-400 rounded-full"></span>
                지행캠퍼스: 010-5647-1320
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-yellow-400 rounded-full"></span>
                옥정캠퍼스: 010-5606-1320
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-yellow-400 rounded-full"></span>
                민락캠퍼스: 010-5492-1320
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-yellow-400 font-bold mb-6 text-sm tracking-wider">학원 정보</h5>
            <ul className="space-y-3 text-sm text-neutral-500">
              <li>학원등록번호: 1130/1180/2543/1225</li>
              <li>사업자번호: 751-98-00707</li>
              <li>대표: 강호석, 김문철, 강창석</li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-gray-900 mb-3">문의</h4>
            <div className="space-y-2">
              <a href="tel:010-5606-1320" className="flex items-center gap-2 text-sm text-gray-600 hover:text-yellow-600 transition-colors cursor-pointer">
                <i className="ri-phone-line"></i>
                <span>010-5606-1320</span>
              </a>
              <a href="mailto:eliteoffuture@naver.com" className="flex items-center gap-2 text-sm text-gray-600 hover:text-yellow-600 transition-colors cursor-pointer">
                <i className="ri-mail-line"></i>
                <span>eliteoffuture@naver.com</span>
              </a>
              <a 
                href="https://yoxomjoamdsqoumvwxha.supabase.co/functions/v1/rss-feed" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-gray-600 hover:text-yellow-600 transition-colors cursor-pointer"
              >
                <i className="ri-rss-line"></i>
                <span>RSS 구독</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-neutral-600">© 2025 미래인재학원. All rights reserved.</p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-neutral-600 hover:text-yellow-400 transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
